<icc-list 
    [items]='styles'
    [tabs]="styleTabs"
    (select)="selectSheathing($event)"
    [selected]="styleId" searchable="true"
    itemImgHeight="medium"
    [itemTemplate]="'itemImgTitle'"
></icc-list>
